module.exports = __webpack_public_path__ + "static/media/BridalSalons.aa9b1e62.png";